module.exports = __webpack_public_path__ + "static/media/fondo.142e2ea8.jpg";